import Swiper, { EffectFade, Navigation, Autoplay, Thumbs, Pagination } from 'swiper';
import 'swiper/scss';
import 'swiper/scss/navigation';
import 'swiper/scss/effect-fade';
import 'swiper/scss/thumbs';

import 'theme/moydom/less/blocks/advantages-slider/image.less';

export default class SwiperAdvantagesImageSlider {
    _slider;
    _objSlider;
    _classSlider;

    constructor(opts = {}) {
        this._slider = null;
        this._objSlider = null;
        this._classSlider = opts.classSlider || '.js-swiper-advantagesImageSlider';
    }

    _createSlider(slider){
        const sliderThumbs = slider.querySelector(this._classSlider+'Thumb');
        const sliderList = slider.querySelector(this._classSlider+'List');

        const sliderThumbsSwiper = new Swiper(sliderThumbs, {
            loop: false,
            spaceBetween: 10,
            slidesPerView: 3,
            breakpoints: {
                768: {
                    spaceBetween: 20,
                },
            }
        });

        const sliderSliderSwiper = new Swiper(sliderList, {
            modules: [EffectFade, Thumbs, Autoplay],
            loop: false,
            effect: "fade",
            slidesPerView: 1,
            thumbs: {
                swiper: sliderThumbsSwiper,
            },
            autoplay: {
                delay: 4000,
                pauseOnMouseEnter: true
            }
        });
    }

    init(){
        this._objSlider = document.querySelectorAll(this._classSlider);
        if (!this._slider && this._objSlider.length > 0) {
            this._objSlider.forEach((item) => {
                this._createSlider(item);
            });

            console.log('Slider Advantages Image init');
        } else {
            console.log('Error Slider Advantages Image init');
        }
    }
}
